module.exports = __webpack_public_path__ + "img/szegyenlos_lanyok_4.10cc10e7.jpg";